const initialState = {
  otpHours: 0,
  otpMinutes: 0,
  otpStatus: 'NOT_STARTED',
  otpError: null,
};

export default initialState;
